import { initializeApp } from "firebase/app"
// const config = {
//   production: {
//     apiKey: "AIzaSyDImq4yV3M3XXjBU8PXNst_WlOFHtb6yzw",
//     authDomain: "pastel-auth.firebaseapp.com",
//     projectId: "pastel-auth",
//     storageBucket: "pastel-auth.appspot.com",
//     messagingSenderId: "425444722441",
//     appId: "1:425444722441:web:9671f59fe13e747436b5d8",
//     measurementId: "G-GTEWXH1FZ0",
//   }
// }

const app = initializeApp({
  apiKey: "AIzaSyDImq4yV3M3XXjBU8PXNst_WlOFHtb6yzw",
  authDomain: "pastel-auth.firebaseapp.com",
  projectId: "pastel-auth",
  storageBucket: "pastel-auth.appspot.com",
  messagingSenderId: "425444722441",
  appId: "1:425444722441:web:9671f59fe13e747436b5d8",
  measurementId: "G-GTEWXH1FZ0",
})
